module.exports = __webpack_public_path__ + "static/media/1-web-or-mls-DSC06995.5ae5113f.jpg";